import { z } from 'zod';

import { BankruptcyId, ForeclosureId } from '../BrandedIds';
import { ReportableEventInput } from '../loan/ReportableEvent';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpsertReportableEvent = BaseLoanEvent.extend({
  type: z.literal('upsertReportableEvent'),
  reportableEvent: ReportableEventInput,
  relatedForeclosureId: ForeclosureId.optional(),
  relatedBankruptcyId: BankruptcyId.optional(),
});
export type UpsertReportableEvent = z.infer<typeof UpsertReportableEvent>;
